<!-- <all-projects *ngIf="oneTenant"></all-projects> -->

@if (isToSelect) {
  <div class="main-content">
    <div class="container-fluid">
      <div class="card sq-card">
        <div class="card-header card-header-squirrel">
          @if (!isAdmin) {
            <h4 class="card-title">{{this.translate.data['SELECTTENANT'] | translate}}</h4>
          }
          @if (isAdmin) {
            <h4 class="card-title">{{this.translate.data['SELECTTENANT'] | translate}} oder als System Manager weiterarbeiten</h4>
          }
        </div>
        <!-- <div class="card-header card-header-squirrel">
        <button matTooltip="{{this.translate.data['ADDTENANT'] | translate}}" mat-raised-button class="btn btn-squirrel pull-right" (click)="addTenant()" *ngIf="tenant">
          <mat-icon>person_add</mat-icon>
        </button>
        <div class="clearfix"></div>
      </div> -->
      <!-- <div class="card-body" [ngSwitch]="gridView">
      <squirrel-data *ngSwitchCase="squirreldbView"></squirrel-data>
      <tenant-data *ngSwitchCase="tenantdbView"></tenant-data>
    </div> -->
    <div class="card-body">
      <!-- <div class="user-tenants-table"> -->
      <!-- <div class="user-tenants-table" style="max-height: 300px; overflow-y: auto;"> -->
      <div class="user-tenants-table" style="max-height: 100%; overflow-y: auto;">
        @if (!isLoadingResults) {
          @for (tenant of userTenants; track tenant.id) {
            <div (click)="onRowClicked(tenant)" class="tenant-row"
                 style="display:flex; align-items:center; justify-content:space-between; width:100%; padding:8px 16px; cursor:pointer; border-bottom:1px solid #e0e0e0;">
              @if (tenant.id !='00000000-0000-0000-0000-000000000000') {
                <div style="flex: 1;">
                  {{tenant.displayName}}
                </div>
              }
              @if (tenant.id =='00000000-0000-0000-0000-000000000000') {
                <div style="flex: 1; background-color: cyan; padding: 4px 8px;">
                  {{tenant.displayName}}
                </div>
              }
              <div style="flex: 1; text-align: right;">
                @if (tenant.image) {
                  <img [src]="'data:image/jpeg;base64,' + tenant.image" style="height:40px; object-fit:cover; border-radius:4px;">
                }
              </div>
            </div>
          }
          <!-- <mat-option *ngFor="let tenant of userTenants" [value]="tenant" >
          <div (click)="onRowClicked(tenant)"
            style="display:flex; align-items:center; cursor:pointer; gap:12px;">
            <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
              {{tenant.displayName}}
            </span>
            <img class="tenantImage"
              *ngIf="tenant.image"
              [src]="'data:image/jpeg;base64,' + tenant.image"
              style="width:40px; height:40px; object-fit:cover;">
            </div>
          </mat-option> -->
        }
        <!-- <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
        <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
        <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
          Squirrel's API rate limit has been reached. It will be reset in one minute.
        </div>
      </div> -->
      <!-- <ag-grid-angular class="ag-theme-balham" style="height: 100%; width: 100%; padding: 5px;"
      [overlayLoadingTemplate]="overlayLoadingTemplate"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      (rowClicked)="onRowClicked($event)"
      [components]="components"
      [animateRows]="true"
    </ag-grid-angular> -->
  </div>
</div>
</div>
</div>
</div>
}





